'use strict';

angular.module('cgmemApp')
	.controller('FrontDeskCCPayCtrl', function ($scope, $log, BrainTree, Transaction, Logger, accountId) {
		this.loading = true;
		this.alert = '';
		this.cardholderName = "";
		this.total = Transaction.getTotal();

		var self = this;

		this.submit = function () {
			self.alert = '';
			self.loading = true;
		}

		var hostedFieldsConfig = {
			styles: {
				".valid": {
					"color": "green"
				},
				".invalid": {
					"color": "red"
				}
			},
			fields: {
				number: {
					selector: "#card-number"
				},
				cvv: {
					selector: "#cvv"
				},
				expirationMonth: {
					selector: "#exp-month",
					placeholder: "MM"
				},
				expirationYear: {
					selector: "#exp-year",
					placeholder: "YYYY"
				}
			}
		};

		var onError = function (err) {
			if (err.type == 'CUSTOMER')
				Logger.log("Braintree onError:", err);
			else
				Logger.log("*** ATTENTION REQUIRED: Braintree onError:", err);
			self.alert = (
				err.type == 'CUSTOMER' ?
					"ERROR: please check the fields highlighted in RED" :
					"ERROR: There was a system problem processing this transaction.  Please try again or contact CG at info@countryglen.org"
			);
			self.loading = false;
		}

		var onPaymentMethodReceived = function (o) {
			var p = new Transaction.transaction(null, null, 'ccpayment', -self.total,
				{
					cardholderName: self.cardholderName,
					nonce: o.nonce,
					receiptAddress: ""
				});
			p.accountId = accountId;

			self.loading = true;
			Transaction.save(p)
				.then(function (data) {
					$scope.$close();
				})
				.catch(function (err) {
					$log.warn("transaction save failed:", err);
					self.loading = false;
					self.alert = err;
				})
				.finally(function () {
				})
		}

		BrainTree
			.init("#cc-form", hostedFieldsConfig, onError, onPaymentMethodReceived)
			.then (() => {
				self.loading = false;
			})
			.catch(err => {
				self.loading = false;
				self.alert = "Error communicating with the Payment Gateway. Please try again later.";
				$log.error('Error communicating with the payment gateway', err);
			});

		$scope.$on("$destroy", function() {
			BrainTree.teardown();
		});
	});